// This JavaScript file is created by Cision for our ticker module.
// Version 1.1

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.tickers = !cision.websolution.settings.ticker ? {} : function ($) {
    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.ticker.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }
    var render = function (options) {
        var sharePerformanceData = null,
            tickerData = null;

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ticker access key.");
            return;
        }
        var urlTicker = generateUrl('Ticker/' + accessKey);

        $.ajax({
            url: urlTicker,
                type: "GET",
                dataType: "json"
            })
            .done(function(dataObj) {
                tickerData = dataObj;
                if (sharePerformanceData) {
                    renderResult(tickerData, sharePerformanceData, texts, settings);
                }
            })
            .fail(function() {
                console.log('Could not retrieve ticker data');
            });
        var urlPerformance = generateUrl('Ticker/' + accessKey + '/Performance');

        $.ajax({
            url: urlPerformance,
            type: 'GET',
            dataType: 'json'
        })
            .done(function (dataObj) {
                sharePerformanceData = dataObj;
                if (tickerData) {
                    renderResult(tickerData, sharePerformanceData, texts, settings);
                }
            });

    };

    function renderResult(tickerData, sharePerformanceData, texts, options) {

        if (options) {
            $.extend(settings, options);
        }

        var compositeModel = $.extend({ tickers: [] }, texts, settings);

        var sortBySymbol = function (s) {
            return _.sortBy(s, "TickerSymbol");
        }

        var sortedTickerData = sortBySymbol(tickerData.Instruments);
        for (var instrumentIx = 0; instrumentIx < sortedTickerData.length; instrumentIx++) {
            var instrument = sortedTickerData[instrumentIx],
                lastDate = "2010-02-01T00:00:00.000000Z",
                ticker;

            for (var i = 0; i < instrument.Quotes.length; i++) {
                var quote = instrument.Quotes[0];
                if (quote.QuoteTime >= lastDate) {
                    ticker = quote;
                }
                lastDate = quote.QuoteTime;
            }

            var model = $.extend({}, ticker, texts);
            model.TickerName = instrument.TickerName;
            model.TickerSymbol = instrument.TickerSymbol;
            model.TradeCurrency = instrument.TradeCurrency;
            if (model.DeltaPercentage) {
                model.DeltaPercentage = model.DeltaPercentage * 100;
            }

            model.Time = moment(model.QuoteTime).locale(settings.uiLanguage).format('HH:mm');
            model.Date = moment(model.QuoteTime).locale(settings.uiLanguage).format('DD MMM YYYY');

            var p = sharePerformanceData.Instruments[instrumentIx],
                useKiloFormat = false, //om tusen
                useMegaFormat = true, //om miljon
                currency = settings.valueSuffix,
                isPrefixedCurrency = false, //före el efter
                kiloPrefix = " k", //prefix, sätts av user
                megaPrefix = " M"; //prefix, sätts av user

            var lastPrice = p.LastPrice || p.ClosePrice1D || -1;
            var numberOfShares = p.NumberOfShares || -1;

            var marketCap = numberOfShares * lastPrice;

            model.mcapTotalRaw = Math.round(marketCap);
            model.mcapTotalKilo = Math.round(marketCap / 1000);
            model.mcapTotalMega = Math.round(marketCap / 1000000);

            if (useKiloFormat) {
                model.mcapTotal = model.mcapTotalKilo + kiloPrefix;
            } else if (useMegaFormat) {
                model.mcapTotal = model.mcapTotalMega + megaPrefix;
            } else {
                model.mcapTotal = model.mcapTotalRaw + megaPrefix;
            }

            if (isPrefixedCurrency) {
                model.mcapTotal = currency + model.mcapTotal;
            } else {
                model.mcapTotal = model.mcapTotal + currency;
            }

            // Instead of returning a NaN, turn this into an empty string if needed
            model.mcapTotal = model.mcapTotal || '';

            if (model.Delta > 0) {
                model.ArrowImageurl = settings.tickerImagePlus;
            } else if (model.Delta < 0) {
                model.ArrowImageurl = settings.tickerImageMinus;
            } else {
                model.ArrowImageurl = settings.tickerImageUnchanged;
            }

            compositeModel.tickers.push(model);
        }

        var $targetTicker = $("#target-ticker");
        var renderedHtml = $("#templateTicker").render(compositeModel, cision.websolution.formatHelpers);
        $targetTicker.html(renderedHtml);
        documentReadyFunctions($targetTicker);
    }

    return {
        render: render
    };
} (jQuery);